import {
  FirstNFreeDiscountComponent,
  type FirstNFreeDiscountForm,
} from '@domains/billing-settings/priv/CustomerDiscount/discounts/first-n-free/FirstNFreeDiscount'
import dayjs from 'dayjs'
import { DiscountType, type FirstNFreeDiscount } from '../api/api'
import { useCreateCustomerDiscount } from '../api/queries'
import type { CreateCustomerDiscountPlugin, CreateCustomerDiscountPluginComponentProps } from '../components/CreateCustomerDiscountDialog'

interface FirstNFreeFactoryProps extends CreateCustomerDiscountPluginComponentProps {}

export const FirstNFreeDiscountFactory = (props: FirstNFreeFactoryProps) => {
  const { mutate: createCustomerDiscount, isLoading } = useCreateCustomerDiscount<FirstNFreeDiscount>(props.customerId)

  const handleCreateFirstNFreeDiscount = (data: FirstNFreeDiscountForm) => {
    return createCustomerDiscount(
      {
        billableId: props.productId,
        discountType: {
          type: DiscountType.FirstNFreeDiscount,
          numberOfFreeItems: data.numberOfFreeItems,
        },
        expirationDate: data.expirationDate ? dayjs(data.expirationDate).format('YYYY-MM-DD') : undefined,
      },
      { onSuccess: () => props.onCreatedDiscount() },
    )
  }

  return <FirstNFreeDiscountComponent isPatching={isLoading} onCreateFirstNFreeDiscount={handleCreateFirstNFreeDiscount} />
}

export class FirstNFreeDiscountPlugin implements CreateCustomerDiscountPlugin {
  name: string = 'First n free'
  getComponent() {
    return FirstNFreeDiscountFactory
  }
  supports(discountType: string) {
    return discountType === 'First n free'
  }
}
